import { render, staticRenderFns } from "./ImpresionMovimiento.vue?vue&type=template&id=389dcc2e&scoped=true&"
import script from "./ImpresionMovimiento.vue?vue&type=script&lang=js&"
export * from "./ImpresionMovimiento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389dcc2e",
  null
  
)

export default component.exports